import { api } from "../../api";
import { USER_ENDPOINTS } from "../../../constants/endpoints";

export const reportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getReportByDate: builder.query({
      query: ({ startDate, endDate }) => ({
        url: USER_ENDPOINTS.REPORT_ENDPOINTS,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ startDate, endDate }),
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetReportByDateQuery } = reportApi;
